<script lang="ts" setup>
import {getFileText, ITextFileAndContents} from '../../lib/FileUtils';
import FileSelectButton from '../Buttons/FileSelectButton.vue';

    const props = withDefaults(defineProps<{
        label?: string,
        // fileType?: string,
        accept?: string, // .txt, .hl7, etc...
        title?: string,
        disabled?: boolean
    }>(), {
        label: "Import File",
    });

    const emits = defineEmits<
        (e: 'fileSelected', selectedFile: ITextFileAndContents) => void
    >();

    async function textFileContents(file?: File): Promise<string|undefined> {
        if (!file)
            return;

        const contents = await getFileText(file);
        return contents;
    }

    async function fileSelected(file: File)
    {
        emits("fileSelected", { contents: await textFileContents(file), file });
    }

</script>    

<template>
    <FileSelectButton :label="props.label" :accept="props.accept" @fileSelected="fileSelected" />
</template>